import { useEffect, useReducer, useState } from "react";
import {
    faHome,
    faClipboardList,
    faEdit,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ModalComponent from "../../../../../Components/Modais";
import { IComponentModal } from "../../../../../Components/Modais/IModalComponent";
import {
    DeletarFormularioProdutoController,
    ObterFormularioProdutoController,
} from "../../../../../Controllers/Geral/Produtos/ProdutosControllers";
import { IEmpreendimento } from "../../../../../Interfaces/Geral/Produtos/ProdutosInterface";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import Swal from "sweetalert2";
import EditarFormularioProduto from "../EditarFormularioProduto";

interface IEditarFormState {
    idFormularioProduto: number;
    recemCriado: boolean;
}

function editarFormReducer(
    current: IEditarFormState,
    action: IEditarFormState | number
) {
    if (typeof action === "number") {
        return {
            idFormularioProduto: action,
            recemCriado: false,
        };
    } else {
        return action;
    }
}

interface IListarProdutosEFormularioProps {
    produto: IEmpreendimento;
    updateList: () => void;
}

export default function ListarProdutosEFormulario(
    props: IListarProdutosEFormularioProps
) {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const { value: obterFormularioProduto } = useAsyncEffect(
        () =>
            ObterFormularioProdutoController(props.produto?.ID_EMPREENDIMENTO),
        []
    );

    const [formularioEmEdicao, setFormularioEmEdicao] = useReducer(
        editarFormReducer,
        {
            idFormularioProduto: 0,
            recemCriado: false,
        }
    );

    useEffect(() => {
        if (formularioEmEdicao.idFormularioProduto !== 0) {
            setShow(true);
            setModal({
                noHeader: true,
                noBody: true,
                noFooter: true,
                IconHeader: faClipboardList,
                onClose: () => setFormularioEmEdicao(0),
                Component: () => (
                    <EditarFormularioProduto
                        idFormularioProduto={
                            formularioEmEdicao.idFormularioProduto
                        }
                        ID_EMPREENDIMENTO={props.produto?.ID_EMPREENDIMENTO}
                        recemCriado={formularioEmEdicao.recemCriado}
                        setModal={setModal}
                        setShow={setShow}
                        updateList={props.updateList}
                    />
                ),
                size: "lg",
            });
        }
    }, [
        formularioEmEdicao,
        props.produto?.ID_EMPREENDIMENTO,
        props.updateList,
    ]);

    return (
        <div className="w-100 card card-custom p-6">
            <div>
                <h4>
                    <FontAwesomeIcon icon={faHome} className="text-info mr-5" />
                    {props.produto.DS_EMPREENDIMENTO}
                </h4>
                <hr />
                <div className="Button-Tools">
                    {obterFormularioProduto ? (
                        <>
                            <button
                                className="btn btn-outline-primary font-weight-bold mr-2"
                                onClick={() => {
                                    setFormularioEmEdicao(
                                        obterFormularioProduto.ID_FORMULARIO_PRODUTO
                                    );
                                }}
                            >
                                <FontAwesomeIcon icon={faEdit} size="lg" />
                                Editar Formulário
                            </button>
                            <button
                                className="btn btn-outline-danger font-weight-bold mr-2"
                                onClick={() => {
                                    Swal.fire({
                                        title: "Deseja apagar este Formulário?",
                                        icon: "info",
                                        buttonsStyling: false,
                                        confirmButtonText:
                                            "<i class='la la-check'></i> Sim!",
                                        showCancelButton: true,
                                        cancelButtonText:
                                            "<i class='la la-thumbs-down'></i> Não",
                                        customClass: {
                                            confirmButton:
                                                "btn btn-outline-success",
                                            cancelButton: "btn btn-default",
                                        },
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            DeletarFormularioProdutoController(
                                                obterFormularioProduto?.ID_FORMULARIO_PRODUTO
                                            ).then(() => props.updateList());
                                        }
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} size="lg" />
                                Excluir Formulário
                            </button>
                        </>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
